import { render, staticRenderFns } from "./SelectCharts.vue?vue&type=template&id=3b22c3b7&scoped=true&"
import script from "./SelectCharts.vue?vue&type=script&lang=js&"
export * from "./SelectCharts.vue?vue&type=script&lang=js&"
import style0 from "./SelectCharts.vue?vue&type=style&index=0&id=3b22c3b7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b22c3b7",
  null
  
)

export default component.exports